import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useSite } from "../../util/sites";
import { useRouter } from "../../util/router";
import SiteSelectComp from "./SiteSelectComp";

function NavbarSelect() {
	const currentSite = useSite();
	const router = useRouter();
	const [options, setOptions] = useState(currentSite.allSites_Select);
	const [selectedSite, setSelectedSite] = useState(currentSite.defaultSelect);

	const find_OP = (obj) => {
		switch (obj.operation_status) {
			case 1:
				return "#00757e";
			case 2:
				return "#ff8500";
			case 4:
				return "#8dc63f";
			default:
				return "#666666";
		}
	};

	const selectStyle = {
		option: (provided, state) => ({
			...provided,
			color: find_OP(state.data.value),
			fontSize: "13px",
		}),
		menuList: (provided, state) => ({
			...provided,
			maxHeight: "500px",
		}),
		groupHeading: (provided, state) => ({
			...provided,
			fontSize: "13px",
			color: "#a4aaaa",
			borderTop: "#a4aaaa 1px solid",
		}),
		singleValue: (provided, state) => {
			const fontSize = "13px";
			return { ...provided, fontSize };
		},
	};

	/**
	 * Handle select change
	 * @param {Select object of site} obj
	 */
	const handleChange = (obj) => {
		switch (obj.label) {
			case currentSite.defaultSelect.label:
				router.push("/solar/overview");
				break;

			default:
				if (
					router.pathname == "/solar/overview" ||
					router.pathname.includes("/solar/dashboard")
				)
					router.push(`/solar/dashboard/${obj.value.site_id}`);

				break;
		}

		currentSite.changeSite(obj);
	};

	useEffect(() => {
		if (
			currentSite.allSites_Select != null &&
			currentSite.allSites_Select.length > 0
		)
			setOptions(currentSite.allSites_Select);
	}, [currentSite.allSites_Select]);

	useEffect(() => {
		if (currentSite.selectedSite != null)
			setSelectedSite(currentSite.selectedSite);

		return () => {
			setSelectedSite(currentSite.defaultSelect);
		};
	}, [currentSite.selectedSite]);

	return (
		options != null &&
		options.length > 0 &&
		selectedSite != null &&
		currentSite.showSelect && (
			<SiteSelectComp
				defaultValue={currentSite.defaultSelect}
				options={options}
				handleSite={handleChange}
				selectedSite={selectedSite}
				styles={selectStyle}
				isSelected={true}
			/>
		)
	);
}

export default NavbarSelect;
